// import QueryString from "qs";

import axios from "../axios";
import { BASE_URL } from "@src/utils";

// 트리츠스파의 날짜 슬롯 가져오기
export interface IResTreatzSpaDateSlot {
  [date: string]: IResTreatzSpaDateSlotItem[];
}
export interface IResTreatzSpaDateSlotItem {
  treatzSpaReservationId: number;
  visitTime: string;
  stock: number;
}
export const getTreatzSpaDateSlot = async (dates: string) => {
  const res = await axios.get<{ item: IResTreatzSpaDateSlot }>(
    `${BASE_URL}/v4/treatz-spa/calendar?dates=${dates}`,
  );
  return res.data.item;
};

// 트리츠스파 예약하기
export interface IReqTreatzSpaReservation {
  treatzSpaReservationId: number;
  numberOfVisitors: number;
  productName: string;
}
export interface IResTreatzSpaReservation {
  treatzSpaReservationClaimId: number;
}
export const postTreatzSpaReservation = async (params: IReqTreatzSpaReservation) => {
  const res = await axios.post<{ item: IResTreatzSpaReservation }>(
    `${BASE_URL}/v4/treatz-spa/reservation`,
    params,
  );
  return res.data.item;
};

// 트리츠스파 예약 상세
export interface IResTreatzSpaReservationDetail {
  visitDate: string;
  numberOfVisitors: number;
  productName: string;
}
export const getTreatzSpaReservationDetail = async (reservationId: number) => {
  const res = await axios.get<{ item: IResTreatzSpaReservationDetail }>(
    `${BASE_URL}/v4/treatz-spa/reservation/${reservationId}`,
  );
  return res.data.item;
};
